import {Component, OnDestroy, OnInit, Signal, signal, ViewChild, WritableSignal} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin, lastValueFrom} from "rxjs";
import {ButtonDirective} from "primeng/button";
import {DetallePagoDto, RequestFinalizaPago} from "../../../../shared/interfaces/recaudo";
import {CurrencyPipe, DatePipe, DecimalPipe, NgClass, NgIf} from "@angular/common";
import {
  AlertIcon, AlertService, LoadingPanelService, SafeResourcePipe,
  SessionStorageService, Utils, VisorComponent
} from "lib-base";
import {SkeletonModule} from "primeng/skeleton";
import {PseTransactionService} from "../../../../services/recaudo/pse-transaction.service";
import {Router} from "@angular/router";
import {FacturaService} from "../../../../services/liquidacion/factura.service";
import {TramiteFirmasElectronicasService} from "../../../../services/tramiteFirmasElectronicas.service";
import {RequestGenerarFirmadoDigital} from "../../../../shared/interfaces/firma_electronica";
import {ReciboService} from "../../../../services/recibo.service";
import {IDataSolicitud, IReimpresionFactura} from "../../../../shared/interfaces/liquidacion";
import {TramRegistroSolicitudService} from "../../../../services/tramiteRegistroSolicitud.service";


@Component({
  selector: 'app-comprobante-pago',
  standalone: true,
  imports: [
    ButtonDirective,
    DatePipe,
    NgIf,
    SafeResourcePipe,
    SkeletonModule,
    DecimalPipe,
    VisorComponent,
    NgClass,
  ],
  templateUrl: './comprobante-pago.component.html',
  styleUrl: './comprobante-pago.component.scss'
})


export class ComprobantePagoComponent implements OnInit, OnDestroy {

  translations: any = {};
  numeroRadicado: WritableSignal<string> = signal<string>('');
  title: Signal<string> = signal('comprobante-pago');

  detallePago: DetallePagoDto | null = null;
  #idTramite!: number;
  loteFactura!: number;
  url: string | null = null;
  documentoRadicado: Blob | null = null;

  constructor(private _t: TranslateService, private pseTransaction: PseTransactionService,
              private _lps: LoadingPanelService, private alertService: AlertService,
              private router: Router, private tramRegistroSolService: TramRegistroSolicitudService,
              private reciboService:ReciboService,
              private tramFirmadoService:TramiteFirmasElectronicasService,
              private sessionStorage: SessionStorageService) {
    this.getSolcitud();
  }

  async ngOnInit() {
    await this.getTranlations();
    this._lps.show();
    this.getResultadoTransaccion();
    this.getDocumentoRadicado();
    this.getRadicadoSolicitud()

  }

  ngOnDestroy(): void {
    this.sessionStorage.removeItem(this.sessionStorage.DETALLE_SOLICITUD)
  }

  private async getTranlations() {
    this.translations = await firstValueFrom(forkJoin({
      header: this._t.get('components.app-comprobante-pago.header'),
      subHeader: this._t.get('components.app-comprobante-pago.sub-header'),
      subHeader2: this._t.get('components.app-comprobante-pago.sub-header2'),
      headerTransaction: this._t.get('components.app-comprobante-pago.header-transaccion'),
      estado: this._t.get('components.app-comprobante-pago.state'),
      valorPago: this._t.get('components.app-comprobante-pago.value'),
      nombreBanco: this._t.get('components.app-comprobante-pago.bank'),
      tramite: this._t.get('components.app-comprobante-pago.description-pay'),
      volver: this._t.get('form.button.finalizar'),
      fechaTransaccion: this._t.get('components.app-comprobante-pago.trans-date'),
      horaTransaccion: this._t.get('components.app-comprobante-pago.trans-hour'),
      codServicio: this._t.get('components.app-comprobante-pago.srv-code'),
      cus: this._t.get('components.app-comprobante-pago.cus'),
      ticket: this._t.get('components.app-comprobante-pago.ticket'),

      titleWarnMsg: this._t.get('form.msg.warn-summary'),
      messageWarnMsg: this._t.get('components.app-comprobante-pago.msg-warn-detalle-factura'),

      continuar: this._t.get('common.continuar'),
      imprimirComprobante: this._t.get('components.app-comprobante-pago.radicar'),
      descargar: this._t.get('common.descargar'),

    }));
  }

  getSolcitud() {
    const item : IDataSolicitud | null = this.sessionStorage.getItem(this.sessionStorage.DETALLE_SOLICITUD);
    if (item) {
      this.#idTramite = item?.solicitud as number;
      this.loteFactura = item?.lote as number;
    } else {
      this.router.navigate(['/tramites', 'estado-tramite'])
    }
  }

  getRadicadoSolicitud(){
    this._lps.show();
    this.tramRegistroSolService.getRadicado(this.#idTramite).subscribe({
      next: (value:number) => {
        this.numeroRadicado.set( `${value},`);
        this._lps.hide();
      }, error: err => {
        this.alertService.show({
          icon: AlertIcon.WARN,
          title: 'Atención',
          text: 'No se pudo obtener el radicado',
          showAccept: true
        })
      }
    });
  }

  getResultadoTransaccion() {
    this._lps.show();
    this.pseTransaction.getResultadoTransaccion(this.#idTramite).subscribe({
      next: value => {
        this.detallePago = value;
        this._lps.hide();
      }, error: err => {
        this._lps.hide();
        this.alertService.show({
          icon: AlertIcon.WARN,
          title: 'Atención',
          text: 'No se pudo obtener el detalle de la transaccion',
          showAccept: true
        })
      }
    })
  }

  get isMobile() {
    return Utils.isMobile();
  }

  getDocumentoRadicado() {
    this._lps.show();
    const body:RequestGenerarFirmadoDigital =  {
      tramRegistroSolicitud: this.#idTramite
    };
    this.tramFirmadoService.generarTramiteFirmado(body).subscribe({
      next: value =>{
        this.documentoRadicado = value;
        this.url = URL.createObjectURL(this.documentoRadicado);
        this._lps.hide();
        this.sendEmailRadicado().then();
      }, error: err => {
        this._lps.hide();
      }
    })
  }

  reimprimirRecibo() {
    let data = {
      loteFacturacion: this.loteFactura,
      solicitud: this.#idTramite
    } as IReimpresionFactura

    this._lps.show(true);
    this.reciboService.reimpresionFactura(data).subscribe({
      next: value => {
        this._lps.hide();
        this.url = URL.createObjectURL(value);
      },error:  err => {
        this.alertService.show({
          icon: AlertIcon.WARN,
          title: 'Atención',
          text: 'No se pudo cargar la informacion',
          showAccept: true
        })
      }
    })
  }

  private async sendEmailRadicado() {
    return await lastValueFrom(this.tramFirmadoService.enviarTramiteFirmado(this.#idTramite))
  }

  redirectToHome(){
    this.router.navigate(['/tramites', 'estado-tramite'])
  }
}
